import Employee from './Employee'
export class ChangePasswordRequest {
    Username: string;
    EmployeeID: number;
    RequireCurrentPassword: boolean;
    CurrentPassword?: string;
    NewPassword?: string;
    SavedByEmployee: Employee;
}

export default ChangePasswordRequest;